import { Form, Formik } from 'formik';
import { isEqual } from 'lodash';
import { DisbursementConfigContainer } from './disbursementConfigStyled';
import {
  useGetDisbursementConfiguration,
  usePostDisbursementConfiguration,
  useWealthlaneAwardSettlementApi,
} from '../../../hooks';
import Button from '../../../components/button';
import Spinners from '../../../components/spinner';
import { COLORS } from '../../../constants/style/color';
import { PageHeader } from '../company-profile/profile.styled';
import Heading from '../../../components/typography';
import FormSelect from '../../../components/dropdown/formSelect';
import { booleanYesNo } from '../../../constants/common';

const DisbursementConfig = () => {
  const { handleRequest } = useWealthlaneAwardSettlementApi();

  const { mutate, isLoading } = usePostDisbursementConfiguration(handleRequest);

  const handleSubmit = (values: any) => {
    mutate(values);
  };

  const { data: disbursementConfiguration, isLoading: disbursementConfigurationLoading } =
    useGetDisbursementConfiguration(handleRequest);

  return (
    <>
      <PageHeader>
        <Heading variant='h3' title='Disbursement Configuration' />
        <Heading
          variant='body-s'
          title='Set up disbursement validation configuration.'
          color={COLORS.Gray}
        />
      </PageHeader>
      <DisbursementConfigContainer>
        {disbursementConfigurationLoading ? (
          <div className='flex justify-center items-center'>
            <Spinners />
          </div>
        ) : (
          <Formik
            initialValues={
              disbursementConfiguration
                ? {
                    isEnabled: disbursementConfiguration?.isEnabled ?? false,
                  }
                : { isEnabled: false }
            }
            enableReinitialize
            onSubmit={(values) => {
              handleSubmit(values);
            }}>
            {({ setFieldValue, handleChange, values, errors, touched }) => {
              return (
                <Form id='disbursement-config-form'>
                  <div className='grid lg:grid-cols-12 md:grid-cols-1 gap-x-8 '>
                    <div className='lg:col-span-4 col-span-1 '>
                      <FormSelect
                        label='Enable Disbursement Validation'
                        name='isEnabled'
                        onChange={(value: any) => {
                          handleChange(value);
                        }}
                        errors={errors}
                        touched={touched}
                        options={booleanYesNo}
                        values={values}
                        arrValue={values?.isEnabled}
                        setFieldValue={setFieldValue}
                        containerClassName='formGroup'
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <Button
                      title={`Save`}
                      type='submit'
                      variant={'primary'}
                      loading={isLoading}
                      disabled={
                        isLoading ||
                        values?.isEnabled === null ||
                        isEqual(values, disbursementConfiguration)
                      }
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </DisbursementConfigContainer>
    </>
  );
};

export default DisbursementConfig;
